import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { Eyebrow, MaskLine } from "./Reveal";

const Strip = ({ photos }) => (
  <div className="flex shrink-0 gap-4 sm:gap-6 pr-4 sm:pr-6">
    {photos.map((src, i) => (
      <div key={src + i} className="group w-[68vw] sm:w-[340px] lg:w-[400px] aspect-[3/4] clip-cut overflow-hidden bg-[var(--ink-3)]">
        <img src={src} alt="A.R.R.O.W training" loading="lazy"
          className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700" />
      </div>
    ))}
  </div>
);

export const Gallery = () => {
  const { t } = useLang();
  const photos = useSite().imgs("gallery");
  if (!photos.length) return null;
  const loop = photos.length < 4 ? [...photos, ...photos] : photos;
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 border-t border-[var(--line)] overflow-hidden">
      <div className="px-5 sm:px-8 lg:px-12 mb-12">
        <Eyebrow>{t("gallery.eyebrow")}</Eyebrow>
        <h2 className="font-display font-black uppercase text-5xl sm:text-7xl leading-[0.85] mt-5">
          <MaskLine>{t("gallery.title")[0]}</MaskLine>
          <MaskLine delay={0.1}>{t("gallery.title")[1]}</MaskLine>
        </h2>
      </div>
      <div className="gallery-track flex w-max" style={{ animationDuration: `${loop.length * 7}s` }}>
        <Strip photos={loop} /><Strip photos={loop} />
      </div>
    </section>
  );
};
